/** @jsxImportSource @emotion/react */
import { Approval, Edit, Error,} from '@mui/icons-material';
import { Grid,IconButton,Typography, useTheme } from '@mui/material';
import { DataGrid, GridCellParams, GridColDef,} from '@mui/x-data-grid';

import { stripedDateGrid } from '../../../common/CustumEmotionStyles';
import { useTranslation } from 'react-i18next';
import { IProductGroupGuiModel } from '../../../model/IProductGroupGuiModel';
import { remToPixels } from '../../../common/CustomFunctions';

interface IProps {
    gridRows: IProductGroupGuiModel[],
    gridRowsErrors: string[],
    loader: boolean,
    handleOpenDialog: (type: "put" | "post", id?: number, name?: string, vatRId?: string, tSales?: string, tDiscount?: string, nTSales?: string, ntDiscount?: string) => void,
}

const DatagridProductGroup = (props: IProps): JSX.Element => {

    const theme = useTheme();

    const { gridRows, gridRowsErrors, loader } = props;

    const { t, i18n } = useTranslation();

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'id', width: 120, hide: true },
        { field: 'name', headerName: t('basic.name'), minWidth: 100, flex: 2,},
        { field: 'vatId', headerName: t('productGroup.vatRateId'), width: 100, flex: 1,},
        { field: 'taxableSales', headerName: t('productGroup.taxableSales'), minWidth: 100, flex: 1,},
        { field: 'taxableDiscount', headerName: t('productGroup.taxableDiscount'), minWidth: 100, flex: 1,},
        { field: 'nonTaxableSales', headerName: t('productGroup.nonTaxableSales'), minWidth: 100, flex: 1,},
        { field: 'nonTaxableDiscount', headerName: t('productGroup.nonTaxableDiscount'), minWidth: 120, flex: 1, },
        {
            field: "edit", headerName: "", width: 60, renderCell: (param: GridCellParams): JSX.Element => {
                return <IconButton onClick={() => props.handleOpenDialog(
                    "put",
                    param.row.id,
                    param.row.name,
                    param.row.vatId,
                    param.row.taxableSales,
                    param.row.taxableDiscount,
                    param.row.nonTaxableSales,
                    param.row.nonTaxableDiscount)}><Edit color="info" /></IconButton>
            }
        },
    ];

    function CustomErrorOverlay() {
        return <Grid container direction="column" justifyContent="center" alignItems="center" height="100%">
            <Grid item><Error fontSize="large" /></Grid>
            <Grid item width="15rem" display="flex" justifyContent="center">
                <Typography variant="body2">
                    {t("basic.unexpectedError")}
                </Typography>
            </Grid>
        </Grid>
    }
    return <><DataGrid css={stripedDateGrid(theme, theme.palette.grey[200])}
        rows={gridRows}
        columns={columns}
        rowHeight={remToPixels(2)}
        loading={loader}
        headerHeight={remToPixels(4)}
        getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
        }
        error={gridRowsErrors && gridRowsErrors.length > 0 ? true : undefined}
        components={{
            ErrorOverlay: CustomErrorOverlay,
        }} />
    </>
}

export default DatagridProductGroup;